import { css } from 'styled-system/css';

export const swiperContainerStyle = {
	swiper: css({
		flex: '0 0 auto',
		width: '100%',
		position: 'relative',
		rounded: '6px',
		bg: 'url("/images/features/tutorial-image_bg.png") no-repeat var(--s400)',
		backgroundSize: '312px',
		backgroundPositionX: 'center',
		backgroundPositionY: 'top',
		_dark: {
			backgroundPositionY: 'bottom',
		},
	}),
	imageWrap: css({
		pos: 'relative',
		width: '246px',
		height: '256px',
		mx: 'auto',
	}),
	navButton: css({
		position: 'absolute',
		top: '50%',
		mt: '-12px',
		color: 'black.5',
		zIndex: 1,
	}),
	prevButton: css({
		left: '4px',
	}),
	nextButton: css({
		right: '4px',
		transform: 'rotate(180deg)',
	}),
	pager: css({
		display: 'flex',
		justifyContent: 'center',
		pt: '6px',
		pb: '6px',
		gap: '3px',
	}),
	dot: css({
		width: '4px',
		height: '4px',
		rounded: '6px',
		bgColor: 'black.3',
		transition: 'all 200ms ease-in',
		_active: {
			width: '12px',
			bgColor: 'brand.500',
		}
	}),
}